module.exports = __webpack_public_path__ + "img/royalblue-ribbon.30e8ae20.svg";